'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import { FullPriceContainerBlockLarge, PerMonth } from './HighlightedPriceDisplay';
import PriceDisplay from './PriceDisplay';

const HighlightedFreePriceDisplay = () => {
  const currencyCode = useSelector(activeCurrencySelector);
  return /*#__PURE__*/_jsxs(FullPriceContainerBlockLarge, {
    children: [/*#__PURE__*/_jsx(PriceDisplay, {
      dataSelenium: "free-highlighted-price-per-month",
      currencyCode: currencyCode,
      price: 0
    }), /*#__PURE__*/_jsx(PerMonth, {
      children: "/mo"
    })]
  });
};

export default HighlightedFreePriceDisplay;